"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getNodeCacheKey;
const shared_1 = require("../shared");
function getNodeCacheKey(initDataHash, nodePath, suffix) {
    return (0, shared_1.hash)(`${initDataHash}/${nodePath}/${suffix}`).toString();
}
//# sourceMappingURL=getNodeCacheKey.js.map